// Libraries
import {persistCache} from 'apollo3-cache-persist';
import {useEffect, useState} from 'react';

interface UsePersistCacheArgs {
  cache: Parameters<typeof persistCache>[0]['cache'];
  storage: Parameters<typeof persistCache>[0]['storage'];
  maxSize?: number;
  debug?: boolean;
}

const usePersistCache = ({cache, storage, maxSize, debug}: UsePersistCacheArgs) => {
  const [isPersisted, setIsPersisted] = useState(false);

  useEffect(() => {
    const initialize = async () => {
      console.log('[Apollo] Loading persisted cache...');
      await persistCache({cache, storage, debug, maxSize});
      console.log('[Apollo] Loaded persisted cache.');
      setIsPersisted(true);
    };

    initialize();
  }, [cache, storage, maxSize, debug]);

  return {
    isPersisted,
  };
};

export default usePersistCache;
